import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'clsx';

import { TIP_SELECTOR_TEST_ID } from 'routes/Checkout/ReviewAndPayment/TipSelector/const';

import styles from './styles.module.scss';
import { useOrderDetails } from 'routes/Checkout/context/OrderDetails';
import { useCart } from 'hooks/context/cart';
import { useMerchant } from 'hooks/context/merchant';
import { useDebounce } from '@clover-util/use-debounce';
import { useInvoiceSummary } from 'routes/Checkout/context/InvoiceSummary';
import { useServiceType } from 'hooks/context/serviceType';
import { DOORDASH_DEFAULT_TIP_SUGGESTION, DOORDASH_TIP_SUGGESTIONS } from './DoordashTipValues';
import { useRunningOrder } from 'hooks/context/RunningOrder';
import { TipSelector } from 'components/TipSelector';

export const HookedTipSelector = memo(function HookedTipSelector() {
  const { t } = useTranslation();
  const { locale } = useMerchant();
  const { subtotal } = useCart();
  const { invoiceSummary } = useInvoiceSummary();
  const { merchant } = useMerchant();
  const { setTipValue: setTipValueImpl } = useOrderDetails();
  const { isDelivery } = useServiceType();
  const { items } = useCart();
  const runningOrder = useRunningOrder();

  const setTipValue = useDebounce(setTipValueImpl, 250, [setTipValueImpl]);
  const totalAmount = invoiceSummary?.subtotal || subtotal;

  if ((!merchant?.tipsEnabled && !isDelivery) || (items.length === 0 && !runningOrder.hasItems)) return null;

  const tipSuggestions = isDelivery ? DOORDASH_TIP_SUGGESTIONS : merchant?.tipSuggestions;
  const defaultTipSuggestion = isDelivery ? DOORDASH_DEFAULT_TIP_SUGGESTION : undefined;

  return (
    <div className={cx(styles.wrapper)} data-testid={TIP_SELECTOR_TEST_ID.root}>
      <h3 className={cx('h6')}>{isDelivery ? t('checkoutPage.leaveATipForDriver') : t('checkoutPage.leaveATip')}</h3>
      <TipSelector
        tipSuggestions={tipSuggestions ?? []}
        defaultTipSuggestion={defaultTipSuggestion}
        totalAmount={totalAmount}
        onTipSelect={setTipValue}
        showNoneTip={!isDelivery}
        locale={locale}
      />
    </div>
  );
});
